import {DatabaseCode, toDatabaseCode} from "./database-code";

export interface ValveType extends DatabaseCode {
  bcp47Code?: string
}

const drain: ValveType = {
  code: 'DRAIN',
  displayValue: {
    id: 'common.entity.valvetype.drain',
    defaultMessage: 'Drain',
  },
};

const sales: ValveType = {
  code: 'SALES',
  displayValue: {
    id: 'common.entity.valvetype.sales',
    defaultMessage: 'Sales',
  },
};

const overflow: ValveType = {
  code: 'OVERFLOW',
  displayValue: {
    id: 'common.entity.valvetype.overflow',
    defaultMessage: 'Overflow',
  },
};

const fill: ValveType = {
  code: 'FILL',
  displayValue: {
    id: 'common.entity.valvetype.fill',
    defaultMessage: 'Fill',
  },
};

const equalizer: ValveType = {
  code: 'EQUALIZER',
  displayValue: {
    id: 'common.entity.valvetype.equalizer',
    defaultMessage: 'Equalizer',
  },
};

const isolation: ValveType = {
  code: 'ISOLATION',
  displayValue: {
    id: 'common.entity.valvetype.isolation',
    defaultMessage: 'Isolation',
  },
};

export const valveType = {
  drain,
  sales,
  overflow,
  fill,
  equalizer,
  isolation,
};

export const valveTypes = Object.values(valveType);

export const toValveType = (code: string): ValveType => toDatabaseCode(code, valveTypes);
export const toValveTypeSafely = (code: string | undefined): ValveType | undefined => code ? toDatabaseCode(code, valveTypes) : undefined;
